/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in tr. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('tr', {
	fields: {
		allowDuplicates: 'Tekrarlanan kartlara izin ver',
		allowReversals: 'Ters kartlara izin ver',
		antardasha: 'Antardasha',
		approximateDate: 'Yaklaşık tarih',
		arcana: 'Arkana',
		aspectTypes: 'Açı türleri',
		avasthaInfo: 'Include avastha details',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: 'Özel ayanamsa değeri',
		biorhythm: 'Biyoritim',
		birthData: 'Doğum bilgileri',
		birthDate: 'Doğum tarihi',
		birthLatitude: 'Doğum enlemi',
		birthLongitude: 'Doğum boylamı',
		birthTime: 'Doğum saati',
		chakra: 'Çakra',
		color: 'Renk',
		context: 'Nerede gördünüz',
		coordinateSystem: 'Koordinat sistemi',
		count: 'Kaç adet',
		currentYear: 'Yıl',
		date: 'Tarih',
		datetime: 'Tarih ve saat',
		day: 'Gün',
		division: 'Bölümsel harita',
		domainWeights: 'Alan ağırlıkları',
		domains: 'Alanlar',
		element: 'Element',
		endDate: 'Bitiş tarihi',
		endDatetime: 'Bitiş tarihi ve saati',
		expression: 'İfade sayısı',
		family: 'Yoga family',
		focus: 'Odak',
		fullName: 'Ad soyad',
		horaryNumber: 'Horary number',
		houseSystem: 'Ev sistemi',
		id: 'Kimlik',
		include: 'Ek gök cisimleri',
		interpretation: 'Konum anlamı',
		intervalMinutes: 'Dakika cinsinden aralık',
		iso2: 'Ülke kodu',
		lang: 'Dil',
		latitude: 'Enlem',
		letter: 'Başlangıç harfi',
		lifePath: 'Yaşam Yolu sayısı',
		limit: 'Sayfa başına sonuç',
		lines: 'Çizgi deseni',
		longitude: 'Boylam',
		mahadasha: 'Mahadasha',
		members: 'Grup üyeleri',
		minSignificance: 'Minimum önem',
		minStrength: 'Minimum güç',
		modernPlanets: 'Modern gezegenleri dahil et',
		month: 'Ay',
		name: 'Ad',
		natalChart: 'Natal harita',
		nodeType: 'Ay düğümü türü',
		number: 'Sayı',
		offset: 'Atlanacak sonuç',
		orb: 'Orb',
		person1: 'Kişi 1',
		person2: 'Kişi 2',
		personA: 'Kişi A',
		personB: 'Kişi B',
		planet: 'Gezegen',
		planets: 'Gezegenler',
		positions: 'Açılım pozisyonları',
		pratyantardasha: 'Pratyantardasha',
		q: 'Arama',
		question: 'Sorunuz',
		relocationLatitude: 'Yer değişikliği enlemi',
		relocationLongitude: 'Yer değişikliği boylamı',
		returnDate: 'Dönüş tarihi',
		returnYear: 'Dönüş yılı',
		scheme: 'Karaka scheme',
		seed: 'Tohum',
		sign: 'Burç',
		significators: 'Include KP significators',
		sookshma: 'Sookshma',
		soulUrge: 'Ruh Arzusu sayısı',
		spreadName: 'Açılım adı',
		startDate: 'Başlangıç tarihi',
		startDatetime: 'Başlangıç tarihi ve saati',
		strictOrbs: 'Daha dar orb kullan',
		suit: 'Takım',
		system: 'Avastha system',
		targetDate: 'Hedef tarih',
		targetMonth: 'Hedef ay',
		time: 'Saat',
		timezone: 'Saat dilimi',
		top: 'Pencere başına öne çıkan olay sayısı',
		transitDate: 'Transit tarihi',
		transitTime: 'Transit saati',
		type: 'Desen türü',
		vedic: 'Vedik',
		western: 'Batı',
		year: 'Yıl',
		zodiac: 'Burç',
	},
	enums: {
		'arcana.major': 'Majör Arkana',
		'arcana.minor': 'Minör Arkana',
		'ayanamsa.custom': 'Özel',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Taç',
		'chakra.Heart': 'Kalp',
		'chakra.Root': 'Kök',
		'chakra.Sacral': 'Sakral',
		'chakra.Solar Plexus': 'Solar Pleksus',
		'chakra.Third Eye': 'Üçüncü Göz',
		'chakra.Throat': 'Boğaz',
		'context.address': 'Adres',
		'context.clock': 'Saat',
		'context.license-plate': 'Plaka',
		'context.phone': 'Telefon',
		'context.price': 'Fiyat',
		'context.receipt': 'Fiş',
		'coordinateSystem.sidereal': 'Sideral',
		'coordinateSystem.tropical': 'Tropikal',
		'element.Air': 'Hava',
		'element.Earth': 'Toprak',
		'element.Fire': 'Ateş',
		'element.Storm': 'Storm',
		'element.Water': 'Su',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Classical',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finans',
		'focus.general': 'Genel',
		'houseSystem.equal': 'Eşit Ev',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Tam Burç',
		'lang.de': 'Almanca',
		'lang.en': 'İngilizce',
		'lang.es': 'İspanyolca',
		'lang.fr': 'Fransızca',
		'lang.hi': 'Hintçe',
		'lang.pt': 'Portekizce',
		'lang.ru': 'Rusça',
		'lang.tr': 'Türkçe',
		'nodeType.mean': 'Mean node',
		'nodeType.true': 'True node',
		'planet.Jupiter': 'Jüpiter',
		'planet.Mars': 'Mars',
		'planet.Mercury': 'Merkür',
		'planet.Saturn': 'Satürn',
		'planet.Venus': 'Venüs',
		'scheme.eight': 'Eight karakas',
		'scheme.seven': 'Seven karakas',
		'suit.cups': 'Kupa',
		'suit.pentacles': 'Tılsım',
		'suit.swords': 'Kılıç',
		'suit.wands': 'Değnek',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Compound',
		'type.master': 'Usta',
		'type.mirror': 'Mirror',
		'type.repeating': 'Tekrarlayan',
		'type.root': 'Kök',
		'type.sequential': 'Ardışık',
		'zodiac.aquarius': 'Kova',
		'zodiac.aries': 'Koç',
		'zodiac.cancer': 'Yengeç',
		'zodiac.capricorn': 'Oğlak',
		'zodiac.gemini': 'İkizler',
		'zodiac.leo': 'Aslan',
		'zodiac.libra': 'Terazi',
		'zodiac.pisces': 'Balık',
		'zodiac.sagittarius': 'Yay',
		'zodiac.scorpio': 'Akrep',
		'zodiac.taurus': 'Boğa',
		'zodiac.virgo': 'Başak',
	},
});
